interface BeTagProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'label' | 'line' | 'dot' | 'kbd';
  color?: string;
  light?: boolean;
  round?: boolean;
  icon?: string;
  iconPos?: 'left' | 'right';
  pointDirect?: 'up' | 'down' | 'left' | 'right';
  disabled?: boolean;
  isMeta?: boolean;
  keyType?: string;
}

const BeTag = ({
  children, 
  className = '',
  onClick = () => {}, 
  ...props
}: BeTagProps): JSX.Element => {
  const {
    type = 'label', // line, dot, kbd
    color = null,
    light = false,
    round = false,
    icon = null,
    iconPos = null, // 'right'
    pointDirect = 'up',
    disabled = false,
    isMeta = false,
    keyType = ''
  } = props

  const setClass = [
    type,
    color,
    light && 'light',
    round && 'round',
    icon && 'icon',
    type === 'pointing' && pointDirect,
    type === 'kbd' && isMeta && 'meta',
    type === 'kbd' && keyType,
    disabled && 'disabled'
  ].filter(Boolean).join(' ')

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      onClick(event)
    }
  }

  return (
    <span 
      className={`be-tag ${className} ${setClass}`} 
      onClick={handleClick}
    >
      {icon && iconPos !== 'right' && (
        <i className={`icon ${iconPos} ${icon}`}></i>
      )}
      {(type === 'label' || type === 'pointing' || type === 'kbd') && children}
      {icon && iconPos === 'right' && (
        <i className={`icon right ${icon}`}></i>
      )}
    </span>
  )
}

export default BeTag